import { useState } from 'react';
import { Button, Card, Input, Alert } from '@kss/ui';

export default function Contact() {
  const [sent, setSent] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <div className="mx-auto max-w-3xl px-6 py-16">
      <h1 className="text-4xl font-extrabold tracking-tight">Contact us</h1>
      <p className="mt-2 text-[var(--color-text-secondary)]">
        Tell us what you're building. We'll reply within one business day.
      </p>

      <Card className="mt-8">
        {sent && <Alert variant="success" title="Message sent">We'll get back to you shortly.</Alert>}
        <form onSubmit={handleSubmit} className="mt-4 grid gap-4">
          <Input label="Your name" placeholder="Jane Doe" required />
          <Input label="Email" type="email" placeholder="jane@company.com" required />
          <Input label="Company" placeholder="Acme Inc." />
          <label className="flex flex-col gap-1 text-xs font-medium text-[var(--color-text-secondary)]">
            Message
            <textarea
              rows={5}
              required
              className="rounded-md border border-[var(--color-border)] bg-[var(--color-bg-card)] p-3 text-sm text-[var(--color-text-primary)] outline-none focus:border-[var(--color-primary)]"
              placeholder="How can we help?"
            />
          </label>
          <Button type="submit">Send message</Button>
        </form>
      </Card>
    </div>
  );
}
